import * as React from "react";
import { spacingHelper, Text } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { FacetWithImage } from "../../../../../FacetPickers/components/modules/EcommContent/components/FacetPickers/components/FacetWithImage.js";
import { ShowAllVariantsButton } from "../../../../components/modules/EcommContent/components/VariantsDrawer/components/ShowAllVariantsButton.js";
/* empty css                    */
import { ProductDetailDrawer } from "../../../../../../../ProductDetailDrawer/modules/ProductDetailDrawer/ProductDetailDrawer.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const VariantsDrawer = ({
  title,
  showAllLabel,
  activeFacet,
  onPick,
  isOpen,
  onOpenChange
}) => {
  const {
    product: { productType, flatFacetVariants }
  } = useProductData();
  const { getLabel } = useIntl();
  const activeVariantText = activeFacet?.facetTerm;
  return /* @__PURE__ */ React.createElement(
    ProductDetailDrawer,
    {
      title,
      "data-t": "variants-drawer",
      ctaButton: /* @__PURE__ */ React.createElement(ShowAllVariantsButton, { totalCount: flatFacetVariants.length, label: showAllLabel }),
      shouldMountContent: false,
      isPortalEnabled: true,
      isOpen,
      onOpenChange
    },
    /* @__PURE__ */ React.createElement("div", { className: "variants-drawer__content" }, activeVariantText && /* @__PURE__ */ React.createElement("div", { className: spacingHelper(["mb-5"]) }, /* @__PURE__ */ React.createElement(Text, { variant: "heading-smallest", spacings: ["mr-3"], component: "span" }, getLabel("products.variants.selected")), /* @__PURE__ */ React.createElement(Text, { variant: "body", component: "span" }, activeVariantText)), /* @__PURE__ */ React.createElement("ul", { className: "variants-drawer__list", "aria-label": title }, flatFacetVariants.map((item) => {
      const isActive = item.sku === activeFacet?.sku;
      return /* @__PURE__ */ React.createElement(
        "li",
        {
          key: item.sku,
          className: "variants-drawer__item",
          "aria-current": isActive || void 0
        },
        /* @__PURE__ */ React.createElement("div", { className: "variants-drawer__image-wrapper" }, /* @__PURE__ */ React.createElement(
          FacetWithImage,
          {
            isActive,
            item,
            onPick,
            productType
          }
        )),
        /* @__PURE__ */ React.createElement("div", { className: "variants-drawer__labels" }, item.attributes.map((attribute) => /* @__PURE__ */ React.createElement("div", { key: attribute.key, className: "variants-drawer__label" }, /* @__PURE__ */ React.createElement(Text, { variant: "text-caption-head", spacings: ["mr-3"] }, getLabel(`products.variants.${attribute.key}`)), /* @__PURE__ */ React.createElement(Text, { variant: "text-caption" }, attribute.value))))
      );
    })))
  );
};
export {
  VariantsDrawer
};
//# sourceMappingURL=VariantsDrawer.js.map
